module.exports = __webpack_public_path__ + "img/maximize.e3d48007.svg";